import {immerable} from 'immer';
import Entity from '../entity/Entity';

/**
 * Address entity type definition
 *
 * @typedef {Object} Address
 * @property {?string} street
 * @property {?string} postCode
 * @property {?string} city
 * @property {?string} country
 */

/**
 * Address entity-to-DTO mapping
 *
 * @type {Object<string, EntityDTOProperty>}
 */
const addressEntityDTOMapping = {
    street: {
        dtoProperty: 'street',
        defaultValue: '',
    },
    postCode: {
        dtoProperty: 'postCode',
        defaultValue: '',
    },
    city: {
        dtoProperty: 'city',
        defaultValue: '',
    },
    country: {
        dtoProperty: 'country',
        defaultValue: '',
    },
};

/**
 * Address entity
 *
 * @class
 * @extends Entity
 * @type {Address}
 */
export default class Address extends Entity {
    [immerable] = true;

    static entityDTOMapping = addressEntityDTOMapping;

    /**
     * @constructor
     * @param rawObject
     */
    constructor(rawObject = {}) {
        super();
        this.initialize(rawObject);
    }

    // get displayAddress() {
    //     return [
    //         this.street,
    //         this.postCode,
    //         this.city,
    //         this.country,
    //     ].filter(value => !!value).join(', ');
    // }
}
